import { render, staticRenderFns } from "./SalesTotalSalesComparisonByRegionBarChart.vue?vue&type=template&id=a171fa68"
import script from "./SalesTotalSalesComparisonByRegionBarChart.vue?vue&type=script&lang=ts"
export * from "./SalesTotalSalesComparisonByRegionBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports